import CollectionContainer from '../containers/Collection';
import { waitForElements } from '../helpers/utils';
import SoftLoad from '../modules/SoftLoad';
class CollectionInstoreTemplate extends CollectionContainer {
    constructor() {
        super();
        super.init();
    }
    init() {
        console.log('UNTUCKit : Template : CollectionInstoreTemplate', this);
        SoftLoad.inStoreAsync();
        // accessibility fix for boost filter checkboxes
        waitForElements('.bc-sf-filter-option-multiple-list input[data-value]').then(els => {
            els.forEach(el => el.setAttribute('aria-label', el.dataset.value));
        });
    }
}
$(() => {
    new CollectionInstoreTemplate();
});
